module.exports = __webpack_public_path__ + "089fa578af5742403b770a1d6513b615.fbx";